export default __webpack_public_path__ + "static/collage_image_4-76868520f48dbf8520c3c12d25bdc038.jpg";